/**
 * RefreshPageForGuests Component:
 *
 * This component enforces API route security by ensuring guest users' tokens remain valid.
 *
 * Problem:
 * - Some jurisdiction requires all API routes to be protected by tokens, even for guest users.
 * - Guest tokens have a limited lifespan, defined by 'guest_token_expiration_seconds' in the jurisdiction's configuration.
 * - Without a refresh, guest API requests would fail after the token expires.
 *
 * Solution:
 * - This component automatically reloads the page before the guest token expires.
 * - Upon page reload, the Laravel backend generates a new guest token and updates the browser's cookies.
 * - This ensures continuous API access for guest users.
 *
 * Note:
 * - This component assumes that the Laravel backend automatically generates and sets a new guest token in cookies on page reload.
 * - Automatic guest token refresh is disabled when guest_token_expiration_seconds is set to 0.
 */

import { connect } from 'react-redux';
import { useEffect } from 'react';
import { mapStateToProps, mapDispatchToProps } from '../Store';

const RefreshPageForGuests = ({ user, config }) => {
    if (!config?.config?.guest_token_expiration_seconds || user.loggedIn) {
        return null;
    }

    useEffect(() => {
        const reloadInterval = setInterval(() => {
            window.location.reload();
        }, config.config.guest_token_expiration_seconds * 1000);

        // Clear the interval when the component unmounts
        return () => clearInterval(reloadInterval);
    }, []);

    return null;
};

export default connect(mapStateToProps, mapDispatchToProps)(RefreshPageForGuests);
